import { Fragment } from "react";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import Loader from "../../../components/Loader";

const RtiMis = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: rtiMisData = [], isFetching, isError } = useGetProtectedApiDataQuery({
    url: "rti_mis",
    lang: languageType,
  });

  if (isFetching) return <Loader />;
  if (isError) return <p>Unable to load RTI MIS data. Please try again later.</p>;
  if (!rtiMisData.length) return <p>No RTI MIS data available.</p>;

  const dataByYear = rtiMisData.reduce((groups, item) => {
    const year = item.field_mis_financial_year;
    if (!groups[year]) groups[year] = [];
    groups[year].push(item);
    return groups;
  }, {});

  return (
    <div className="container">
      <div className="responsive_table">
        <table className="table table-striped custom-table table-bordered">
          <thead>
            <tr>
              <th className="no-wrap-td">Month</th>
              <th>Opening Balance</th>
              <th>Received during months (including cases transferred from other public authorities)</th>
              <th>No. of cases transferred to other public authorities</th>
              <th>Decision where requests rejected</th>
              <th>No. of applications in which information provided</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(dataByYear).sort().reverse().map((year) => (
              <Fragment key={year}>
                <tr className="text-center year-header-row">
                  <td colSpan={6}>Year: {year}</td>
                </tr>
                {dataByYear[year].map((item, index) => (
                  <tr key={`${item.field_mis_month_year}-${index}`}>
                    <td className="no-wrap-td">{item.title}</td>
                    <td>{item.field_opening_balance}</td>
                    <td>{item.field_received_during_months}</td>
                    <td>{item.field_no_of_cases_transferred}</td>
                    <td>{item.field_decision_where_requests_re}</td>
                    <td>{item.field_no_of_applications_in_whic}</td>
                  </tr>
                ))}
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RtiMis;
